// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__37gXI","Label":"BuildControl_Label__2th5b","Less":"BuildControl_Less__2_tKg","More":"BuildControl_More__3qDVk"};